
import React, { useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { useFetchData } from 'hooks/apiHooks';
import Toggle from 'components/common/Toggle';
import { useTranslation } from 'react-i18next';
import DeleteButton from 'components/buttons/DeleteButton';
import ApiError from 'components/common/ApiError';
import CardWithLoader from 'components/common/CardWithLoader';
import APIResultMessage from 'components/common/APIResultMessage';
import AddressMap from 'components/common/AddressMap';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import { faMap } from '@fortawesome/free-solid-svg-icons';
import InputList from 'components/common/InputList';
import { API_ENDPOINTS } from 'constants';

const fields = [
    { key: "name", label: "address.label.name", icon: "label", type: "text"},
    { key: "street", label: "address.label.street", icon: "street", type: "text"},
    { key: "postal_code", label: "address.label.postal_code", icon: "state", type: "text"},
    { key: "city", label: "address.label.city", icon: "city", type: "text"},
    { key: "country", label: "address.label.country", icon: "globe", type: "text"},
    { key: "is_primary", label: "address.label.is_primary", type: "checkbox"}
];

const AddressManager = ({contactId, openSection, setOpenSection}) => {
    const { t } = useTranslation();
    const { data, deleteItem, addLine, saveLineKey, isLoading, error, saveError, success, refetch } = useFetchData(API_ENDPOINTS.CUSTOMERS.ADDRESSES(contactId));
    const [openCategory, setOpenCategory] = useState('');
    const [showMap, setShowMap] = useState(false);

    const locations = data?.filter((address) => Number.isFinite(address.latitude) && Number.isFinite(address.longitude))
                            .map((address) => ({ id: address.id, latitude: Number(address.latitude), longitude: Number(address.longitude) }));

    const mapButton = (locations?.length > 0 && <IconButtonWithTooltip translationId='address.showMap' icon={faMap} onClick={()=>{setShowMap(!showMap)}} type="Button" />)

    if(error) return <ApiError retryFetch={refetch} errorMessage={error.message}/>
    return (
        <Toggle text={`${t('address.title')} (${data?.length})`} section={'address'} openSection={openSection} setOpenSection={setOpenSection}>
            <CardWithLoader isLoading={isLoading} footerButtonClick={()=>addLine({id:-1})} footerButtonText={t('address.add')} lines={2} height={40} footerButton={mapButton}>
                <APIResultMessage success={success} error={saveError} />
                {data?.map((item) => (
                    <Row key={item.id} className="align-items-center">
                        <Col md="11">
                            <Toggle text={item.name} section={item.id} openSection={openCategory} setOpenSection={setOpenCategory} emptyValue={null}>
                                <InputList fields={fields} data={item} onChange={(key, value) => saveLineKey(item.id, key, value)}/>
                            </Toggle>
                        </Col>
                        <Col md="1">
                            <DeleteButton deleteItem={deleteItem} id={item.id}/>
                        </Col>
                    </Row>
                ))}
                {showMap &&
                    <Row>
                        <Col md="11">
                            <AddressMap addresses={locations}/>
                        </Col>
                    </Row>
                }
            </CardWithLoader>
        </Toggle>
    );
};

export default AddressManager;
